import React from 'react';
import {createTheme} from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 14,
    lineHeight: 1.2,
    h1: {
      fontSize: 20,
      fontWeight: 600,
      color: '#90A1F6'
    }
  },
  palette: {
    primary: {
      main: '#90a1f6',
      dark: '#7d8cd5',
      light: '#bec8ff',
      contrastText: '#fff'
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ownerState}) => {
          return {
            borderRadius: '24px',
            minWidth: 0,
            padding: React.Children.toArray(ownerState.children).some((child) => typeof child === 'string') ? '6px 16px' : '6px',
          };
        },
      }
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(74,83,124,0.6)',
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        }
      }
    }
  }
});
